module.exports = __webpack_public_path__ + "img/bookmark.bd7886ca.svg";